import split from "lodash/split";
import trim from "lodash/trim";
export default (login, fullName, isParticipant) => {
    const trimmedFullName = trim(fullName || "");
    const trimmedLogin = trim(login || "");
    const name = trimmedFullName || trimmedLogin;
    return {
        name: isParticipant ? split(name, " ")[0] : name,
        bgColor: isParticipant ? "#C2B5F9" : "#6745F1",
        textColor: isParticipant ? "#394F63" : "#FFFFFF"
    };
};
